import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { SocialCommunitiesResourcePackage } from "../../resources/SocialCommunitiesResourcePackage";

export class SocialIconsBackground extends Container {
    private iconsDescription = new Array<IconViewDescription>();

    public constructor(
        socialResources: SocialCommunitiesResourcePackage,
    ) {
        super();
        this.iconsDescription = new Array<IconViewDescription>(
            { position: new Point(0, 279), texture: socialResources.assets_views_social_communities_bg_icons_instagram_png },
            { position: new Point(542, 36), texture: socialResources.assets_views_social_communities_bg_icons_instagram_blur_png },
            { position: new Point(545, 211), texture: socialResources.assets_views_social_communities_bg_icons_facebook_png },
            { position: new Point(596, 1035), texture: socialResources.assets_views_social_communities_bg_icons_facebook_blur_png },
            { position: new Point(178, 955), texture: socialResources.assets_views_social_communities_bg_icons_twitter_blur_png },
            { position: new Point(0, 1217), texture: socialResources.assets_views_social_communities_bg_icons_diskord_png },
            { position: new Point(227, 1429), texture: socialResources.assets_views_social_communities_bg_icons_tik_tok_png },
            { position: new Point(573, 1241), texture: socialResources.assets_views_social_communities_bg_icons_twitter_png }
        );
        this.build();
    }

    private build(): void {
        this.iconsDescription.forEach((item) => {
            const icon = new Sprite(item.texture);
            icon.position = item.position;
            this.addChild(icon);
        });
    }
}

type IconViewDescription = {
    position: Point;
    texture: Texture;
}
